import { render, staticRenderFns } from "./GoLiveWizard.vue?vue&type=template&id=50961eb4&scoped=true"
import script from "./GoLiveWizard.vue?vue&type=script&lang=js"
export * from "./GoLiveWizard.vue?vue&type=script&lang=js"
import style0 from "./GoLiveWizard.vue?vue&type=style&index=0&id=50961eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50961eb4",
  null
  
)

export default component.exports